import React, { useEffect, useState } from "react";
import { useParams, NavLink, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import axios from "axios";
import styles from "./DetailsPage.module.css";
import aboutStyles from "../../about/About.module.css";
import { FaSpinner } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import moment from "moment";
import SocialMedias from "../../../shared/components/socialMedias/SocialMedias";
import { BaseURL, testUrl, universities } from "../BaseData";

const DetailsPage = () => {
    const { t, i18n } = useTranslation(); // Use the translation hook
    const { slug } = useParams();
    const navigate = useNavigate();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [dropdowns, setDropdowns] = useState([]);

    // Find the current page index for active state
    const currentPageIndex = universities.findIndex(item => item.path === `/dropdown/${slug}`);


    useEffect(() => {
        setError(null);
        setLoading(true);
        const fetchDropdown = axios.get(
            testUrl + "/api/dropdowns/" + slug
        );
        const fetchDropdownsData = axios.get(
            testUrl + "/api/dropdowns/"
        );

        Promise.all([fetchDropdown, fetchDropdownsData])
            .then(([dropdownResponse, dropdownsResponce]) => {
                const responseData = dropdownResponse.data;
                const responseDropdowns = dropdownsResponce.data;
                console.log(responseDropdowns);
                if (responseData && responseDropdowns) {
                    setDetails(responseData);
                    setDropdowns(responseDropdowns);
                } else {
                    setError("Ma'lumotlar topilmadi");
                }
            })
            .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
            .finally(() => setLoading(false));
    }, [slug, i18n.language]);

    console.log(dropdowns);

    if (loading) {
        return (
            <div className={styles.center}>
                <FaSpinner className={styles.spinner} />
                <p>{t("loading")}</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.center}>
                <MdErrorOutline className={styles.errorIcon} />
                <p>{t("error")}</p>
            </div>
        );
    }

    // Retrieve language-specific fields
    const siteTitle = details[`site_title_${i18n.language}`];
    const siteDetails = details[`site_details_${i18n.language}`];

    // const mainNews = news.filter((item) => item.is_main).slice(0, 2);
    // const latestNews = news.filter((item) => !item.is_main).slice(0, 4);

    // const settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 3000,
    //     arrows: false,
    //     fade: true,
    // };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.contentContainer}>
                <h1 className={styles.title}>
                    {siteTitle}
                </h1>

                {/* Display all 3 images if they exist */}
                <div className={styles.imagesContainer}>
                    {[
                        { src: details.image1, titleKey: "campus_shayxontohur", mapUrl: "https://www.google.com/maps/place/Renessans+universitet/@41.2830192,69.2265203,13.3z/data=!4m14!1m7!3m6!1s0x38ae8b393418b12f:0xeaab63621741a7d1!2sRENESSANS+TA'LIM+UNIVERSITETI!8m2!3d41.2932424!4d69.2723973!16s%2Fg%2F11scgv0mc7!3m5!1s0x38ae8bbe518958a3:0xabea1d7e79ecbc68!8m2!3d41.3034597!4d69.2155278!16s%2Fg%2F11l2kpbfm2!5m1!1e4?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoASAFQAw%3D%3D" },
                        { src: details.image2, titleKey: "campus_beruniy", mapUrl: "https://www.google.com/maps/place/41%C2%B020'25.2%22N+69%C2%B012'23.5%22E/@41.340319,69.206518,1881m/data=!3m1!1e3!4m4!3m3!8m2!3d41.340319!4d69.206518?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoASAFQAw%3D%3D" },
                        { src: details.image3, titleKey: "campus_yunusobod", mapUrl: "https://www.google.com/maps/place/41%C2%B021'08.0%22N+69%C2%B019'47.6%22E/@41.352211,69.329887,1881m/data=!3m1!1e3!4m4!3m3!8m2!3d41.352211!4d69.329887?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoASAFQAw%3D%3D" }
                    ].map((imgData, index) => imgData.src && (
                        <div key={index} className={styles.imageWrapper}>
                            <img src={imgData.src} alt={`${siteTitle} ${index + 1}`} className={styles.image} />
                            {slug === "oquv-binolari" && (
                                <div className={styles.imageInfo}>
                                    <p className={styles.imageTitle}>{t(imgData.titleKey)}</p>
                                    <a href={imgData.mapUrl} target="_blank" rel="noopener noreferrer" className={styles.mapButton}>
                                        {t("view_on_map")}
                                    </a>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div
                    className={`${styles.content} ck-content`}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(siteDetails, {
                            ADD_TAGS: ["iframe"],
                            ADD_ATTR: [
                                "allow",
                                "allowfullscreen",
                                "frameborder",
                                "scrolling",
                            ],
                        }),
                    }}
                />

            </div>

            <div className={aboutStyles.sidebar}>
                <h3>{t("university")}</h3>
                <ul>
                    {universities.map((item, index) => (
                        (index === currentPageIndex ? (
                            <li className={aboutStyles.active} onClick={() => navigate(item.path)}>
                                <span className={aboutStyles.icon}>
                                    ▶
                                </span>
                                {t(item.text)}
                            </li>
                        ) : (
                            <li onClick={() => navigate(item.path)}>
                                {t(item.text)}
                            </li>
                        ))
                    ))}
                </ul>
                {/* <div className={styles.section}>
                    <h3>{t("socialMedias")}</h3>
                    <SocialMedias/>
                </div> */}
            </div>
        </div>
    );
};

export default DetailsPage;
